import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DeleteSweepRoundedIcon from '@mui/icons-material/DeleteSweepRounded';

interface AppliedFiltersProps {
  appliedFilters: { [label: string]: string[] };
  handleRemoveFilter: (label: string, value: string | null) => void;
  handleClearFilters: () => void;
}

export const AppliedFilters = (props: AppliedFiltersProps) => {
  const { appliedFilters, handleRemoveFilter, handleClearFilters } = props;
  const entries = Object.entries(appliedFilters);

  if (entries.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
      {entries.map(([label, values]) => {
        const displayedValues = values.slice(0, 3);
        const hiddenCount = values.length - displayedValues.length;
        const textContent = `${label}: ${displayedValues.join(', ')}${
          hiddenCount > 0 ? ` +${hiddenCount} more` : ''
        }`;

        return (
          <Chip
            key={label}
            label={textContent}
            onDelete={() => handleRemoveFilter(label, null)}
            deleteIcon={<CloseRoundedIcon sx={{ fontSize: '15px !important' }} />}
            sx={{
              height: 28,
              fontSize: '0.8rem',
              fontWeight: 500,
              bgcolor: 'rgba(16, 185, 129, 0.08)',
              color: '#065f46',
              border: '1px solid rgba(16, 185, 129, 0.2)',
              borderRadius: '9999px',
              '& .MuiChip-deleteIcon': {
                color: '#047857',
                '&:hover': {
                  color: '#065f46',
                },
              },
            }}
          />
        );
      })}

      {entries.length > 0 && (
        <Button
          size="small"
          onClick={handleClearFilters}
          startIcon={<DeleteSweepRoundedIcon sx={{ fontSize: '16px !important' }} />}
          sx={{
            height: 28,
            px: 1.5,
            fontSize: '0.75rem',
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: '9999px',
            color: 'error.main',
            bgcolor: 'rgba(239, 68, 68, 0.08)',
            border: '1px solid rgba(239, 68, 68, 0.2)',
            '&:hover': {
              bgcolor: 'rgba(239, 68, 68, 0.16)',
            },
          }}
        >
          Clear All
        </Button>
      )}
    </Box>
  );
};

